import Navigation from './Navigation';
import Footer from './Footer';

const Layout = ({ children }) => {
  
  return (
    <div className="flex flex-col min-h-screen">
      {/* TopBar - Visible on desktop except on homepage */}
      {/* {!isHomePage && (
        <div className="hidden md:block">
          <TopBar />
        </div>
      )} */}
      
      {/* Navigation */}
      <Navigation />
      
      {/* Main Content */}
      <main className="flex-grow">
        {children}
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Layout;